<template>
  <section class="noData">
    <p>暂无数据</p>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>


<style lang="scss" scoped>
.noData {
  text-align: center;
  p {
    width: 160px;
    padding-top: 90px;
    background: url('../../../static/img/visual/no-data.svg') top center no-repeat;
    background-size: auto 90px;
    font-size: 13px;
    color: white;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/businessModule/noData.vue